module.exports = __webpack_public_path__ + "img/2025-0429-01-01.87360b7a.png";